import React, { useState } from 'react';

const BirthProof = ({ updateFormData, nextStep, prevStep, onExit }) => {
  const [showWaiverMessage, setShowWaiverMessage] = useState(false);

  const handleAnswer = (answer) => {
    if (answer === false) {
      // Show waiver message
      setShowWaiverMessage(true);
    } else {
      nextStep({ hasBirthCertificate: true });
    }
  };

  if (showWaiverMessage) {
    return (
      <div className="question-screen">
        <h1 className="question-title">BIRTH CERTIFICATE REQUIREMENT</h1>

        <div className="question-content">
          <div className="waiver-notice">
            <p>
              When you arrive, the deputy clerk will direct you to a Judge or Justice of the Peace to obtain a waiver.
              The Clerk of Court's fee for this service is $4.00. The Judge or Justice of the Peace granting the waiver
              may charge an additional fee and may require information supporting the need for the waiver.
            </p>
          </div>
        </div>

        <div className="question-actions">
          <button onClick={() => setShowWaiverMessage(false)} className="btn btn-secondary">
            Back to Previous Question
          </button>
          <button onClick={() => nextStep({ hasBirthCertificate: false })} className="btn btn-primary">
            Continue Application
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="question-screen">
      <button onClick={prevStep} className="btn btn-secondary question-back-button">
        Back to Previous Question
      </button>

      <h1 className="question-title">PROOF OF BIRTH INFORMATION</h1>
      <p className="question-subtitle">Reference: <a href="https://legis.la.gov/legis/Law.aspx?d=107004" target="_blank" rel="noopener noreferrer">La. R.S. 9:226</a></p>

      <div className="question-content">
        <p>
          To obtain a marriage license, certified true copies of both parties' birth certificates must be provided to the deputy
          clerk for examination. When completing the application, please refer to the birth certificates so as to provide accurate
          information. The Clerk of Court will retain photocopies of the documents; the originals will be returned to you at the
          time the license is issued.
        </p>

        <p>If either party does not have a certified copy of their birth certificate:</p>

        <p>
          <strong>Louisiana Residents</strong> may obtain them by visiting any of these three Clerk of Court offices: First Parish
          Court, 924 David Dr., Metairie LA 70003; Second Parish Court, 100 Huey P. Long Ave., Gretna LA 70053; or Juvenile Court,
          1546 Gretna Blvd., Harvey LA 70058. For more information on how to obtain birth certificates, visit the clerk of court's
          web site.
        </p>

        <p>
          <strong>Applicants Born Outside of the U.S.</strong> must provide one of the following: a certified true copy of their
          birth certificate; Certificate of Birth Abroad; or Certificate of Naturalization. If the birth certificate is printed
          in a language other than English, a translation is required.
        </p>

        <p>
          If either or both applicants cannot comply with the requirements above, a waiver signed by a Judge or Justice of the
          Peace is needed. The Clerk of Court will provide direction at the time the license is to be issued.
        </p>

        <p className="question-prompt">
          Do you have certified true copies of each applicant's birth certificate (or other documents described above)?
        </p>
      </div>

      <div className="question-buttons">
        <button onClick={() => handleAnswer(true)} className="question-btn yes">Yes</button>
        <button onClick={() => handleAnswer(false)} className="question-btn no">No</button>
      </div>
    </div>
  );
};

export default BirthProof;
